import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IMaterialCost } from './materialCost';
import { IMaterialCostFormValues } from './materialCostFormValues';
import { IMaterialCostUpsert } from './materialCostUpsert';

export default class MaterialCostModelHelper {
    public static createFormValues = (materialId : number, materialCost : IMaterialCost | null) : IMaterialCostFormValues => {
        if (!materialCost) return {
            id: 0,
            guid: uuidV4(),
            materialId: materialId,
            amount: 0,
            currentlyActive: true,
            isActive: true,
        };

        return {
            id: materialCost.id,
            guid: materialCost.guid,
            materialId: materialCost.materialId,
            amount: materialCost.amount,
            currentlyActive: materialCost.currentlyActive,
            isActive: materialCost.isActive,
        };
    };

    public static createUpsert = (formValues : IMaterialCostFormValues) : IMaterialCostUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            materialId: formValues.materialId,
            amount: formValues.amount,
            currentlyActive: formValues.currentlyActive,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IMaterialCostFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        materialId: Yup.number().typeError('Please enter a number.').min(0, 'Value must be larger than 0').required('Required'),
        amount: Yup.number().typeError('Please enter a number.').min(0, 'Amount must be larger than 0').required('Required'),
        currentlyActive: Yup.boolean().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
